import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type PaginatedCustomerOrderV3List } from '../../../../../../src/types/v3/OrderV3';

export type TimeBucket = 'past' | 'current' | 'upcoming';

export type ExpandOrderOptions =
  | 'bundles'
  | 'products'
  | 'shipping_address'
  | 'promo_codes'
  | 'tags'
  | 'tracking_url'
  | 'containers_info'
  | 'available_points'
  | 'grocery_product_count'
  | 'show_flexcredits_message';

export interface CustomerOrdersV3Params {
  expand?: ExpandOrderOptions[];
  limit?: number;
  offset?: number;
  preferred_date_after?: string; // YYYY-MM-DD format
  preferred_date_before?: string; // YYYY-MM-DD format
  status?: number;
  time_bucket?: TimeBucket;
}

export async function getCustomerOrdersV3(params: CustomerOrdersV3Params = {}) {
  const queryParams = new URLSearchParams();

  if (params.expand !== undefined) {
    queryParams.append('expand', params.expand.join(','));
  }

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  if (params.preferred_date_after !== undefined) {
    queryParams.append('preferred_date_after', params.preferred_date_after);
  }

  if (params.preferred_date_before !== undefined) {
    queryParams.append('preferred_date_before', params.preferred_date_before);
  }

  if (params.status !== undefined) {
    queryParams.append('status', params.status.toString());
  }

  if (params.time_bucket !== undefined) {
    queryParams.append('time_bucket', params.time_bucket);
  }

  return await send<PaginatedCustomerOrderV3List>({
    path: '/api/v3/customers/self/orders/',
    method: 'GET',
    query: queryParams,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
